import { FunctionComponent } from 'react';
import styles from './Dots.module.scss';

export type DotsProps = {
  index: number;
  slidesCount: number;
  changeIndex: (idx: number) => void;
};

type FC = FunctionComponent<DotsProps>;

const Dots: FC = ({ index, slidesCount, changeIndex }: DotsProps) => {
  const createDots = () => {
    const dots = [];
    for (let i = 0; i < slidesCount; i++) {
      dots.push(<span key={`dot-${i}`} className={i === index ? styles.active : ''} onClick={() => changeIndex(+i)} />);
    }
    return dots.length > 1 && dots;
  };

  return <div className={styles.dotsContainer}>{createDots()}</div>;
};

export default Dots;
